import { render } from "./AppStore.vue?vue&type=template&id=760a333a"
import script from "./AppStore.vue?vue&type=script&lang=js"
export * from "./AppStore.vue?vue&type=script&lang=js"
script.render = render

export default script